import { TokenForm } from '../TokenForm'

import * as cn from './styles.module.scss'

type Props = {
  network: 'kovan'
}

export const FaucetPage = ({ network }: Props) => {
  return (
    <div className={cn.root}>
      <h1>
        <a href="https://roci.fi" target="_blank" rel="noreferrer">
          RociFi
        </a>{' '}
        {network} testnet faucet
      </h1>
      <TokenForm network={network} />
    </div>
  )
}
